module.exports = __webpack_public_path__ + "img/ImagineerTypesQuiz_Research Imagineer.8f4768f8.png";